import { useTranslation } from 'react-i18next';

interface IBackToMaterialsButtonProps {
  /** The host's class: the Stock tab's link style, or the element list's
   *  variant of it, offset into its padded header. */
  className: string | undefined;
  onClick: () => void;
}

/**
 * "← Back to materials": the Stock tab's one way back to its material list,
 * shared by the element list and the claim form so both exits look and read
 * the same (ruling 2026-09-10).
 */
export function BackToMaterialsButton({ className, onClick }: IBackToMaterialsButtonProps) {
  const { t } = useTranslation();
  return (
    <button type="button" className={className} onClick={onClick}>
      {t('scheduler.panel.stock.backToMaterials')}
    </button>
  );
}
